module.exports = __webpack_public_path__ + "static/media/pt_tr.4e8e91a4.svg";